module.exports = __webpack_public_path__ + "img/quyu.187314e8.png";